/// Helper class to provide a similar functionality of TimeSpan in C#.
export class TimeSpan {
  private constructor(private readonly _ms: number) {}
  static fromMilliseconds(ms: number) { return new TimeSpan(ms); }
  static fromSeconds(s: number)       { return new TimeSpan(s * 1_000); }
  static fromMinutes(m: number)       { return new TimeSpan(m * 60_000); }
  static fromHours(h: number)         { return new TimeSpan(h * 3_600_000); }

  get totalMilliseconds() { return this._ms; }
  get totalSeconds()      { return this._ms / 1000; }
  get totalMinutes()      { return this._ms / 60_000; }
  get totalHours()        { return this._ms / 3_600_000; }

  get hours()   { return Math.floor(this._ms / 3_600_000); }
  get minutes() { return Math.floor(this._ms / 60_000) % 60; }
  get seconds() { return Math.floor(this._ms / 1000) % 60; }
  get millis()  { return this._ms % 1000; }

  add(other: TimeSpan)    { return new TimeSpan(this._ms + other._ms); }
  subtract(other: TimeSpan){ return new TimeSpan(this._ms - other._ms); }

  toStringHMS(): string {
    const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;
    return `${pad(this.hours)}:${pad(this.minutes)}:${pad(this.seconds)}`;
  }
}
